import T from "../../../node_modules/lodash/isArray.js";
import { formatDate as y } from "../../../utils/helper.js";
import { isBefore as B } from "../../../node_modules/date-fns/isBefore.js";
import { isAfter as O } from "../../../node_modules/date-fns/isAfter.js";
import { addMonths as W } from "../../../node_modules/date-fns/addMonths.js";
import { subMonths as L } from "../../../node_modules/date-fns/subMonths.js";
import { startOfMonth as b } from "../../../node_modules/date-fns/startOfMonth.js";
import { startOfWeek as E } from "../../../node_modules/date-fns/startOfWeek.js";
import { endOfWeek as R } from "../../../node_modules/date-fns/endOfWeek.js";
import { addDays as k } from "../../../node_modules/date-fns/addDays.js";
import { isSameDay as l } from "../../../node_modules/date-fns/isSameDay.js";
import { isSameMonth as D } from "../../../node_modules/date-fns/isSameMonth.js";
import { isToday as F } from "../../../node_modules/date-fns/isToday.js";
import { isWithinInterval as S } from "../../../node_modules/date-fns/isWithinInterval.js";
import { isSunday as V } from "../../../node_modules/date-fns/isSunday.js";
import { isSaturday as _ } from "../../../node_modules/date-fns/isSaturday.js";
import { startOfYear as U } from "../../../node_modules/date-fns/startOfYear.js";
import { endOfYear as j } from "../../../node_modules/date-fns/endOfYear.js";
const rt = "d MMM, yyyy", nt = (o) => T(o) && o.length === 0 ? null : o.reduce((t, s) => s < t ? s : t, o[0]), yt = (o) => T(o) && o.length === 0 ? null : o.reduce((t, s) => s > t ? s : t, o[0]), at = (o, t) => {
  t(W(o, 1));
}, it = (o, t) => {
  t(L(o, 1));
}, g = (o) => {
  const t = new Date(o);
  return t.getFullYear() * 12 + t.getMonth();
}, ft = (o, t, s) => {
  const n = g(o);
  return t && n < g(t) ? t : s && n > g(s) ? s : o;
}, lt = [
  { label: "Today", testId: "today" },
  { label: "Yesterday", testId: "yesterday" },
  { label: "Last 7 days", testId: "last-7-days" },
  { label: "This week", testId: "this-week" },
  { label: "Last Week", testId: "last-week" },
  { label: "This month", testId: "this-month" },
  { label: "Last Month", testId: "last-month" }
], Mt = (o, t, s) => {
  if (!t && !s) return !1;
  const n = t ? new Date(y(t, "yyyy-MM-dd")).getFullYear() : -1 / 0, a = s ? new Date(y(s, "yyyy-MM-dd")).getFullYear() : 1 / 0;
  return o < n || o > a;
}, mt = (o, t, s) => {
  const n = /* @__PURE__ */ new Date(), a = o ? B(n, y(o, "yyyy-MM-dd")) : !1, i = t ? O(n, y(t, "yyyy-MM-dd")) : !1, f = s ? n.getDay() === 5 || n.getDay() === 6 : !1;
  return a || i || f;
}, ct = (o, t, s, n, a, i, f, h) => {
  const u = new Date(o).getFullYear(), p = new Date(o).getMonth(), M = b(new Date(u, p)), c = E(M), d = R(k(c, 41)), r = [];
  let e = c;
  for (; e <= d; ) {
    const w = n ? B(y(e, "yyyy-MM-dd"), y(n, "yyyy-MM-dd")) : !1, I = a ? O(y(e, "yyyy-MM-dd"), y(a, "yyyy-MM-dd")) : !1, A = !!(i != null && i.some((Y) => l(e, Y))), m = !!(f != null && f.some((Y) => l(e, Y))), C = h ? e.getDay() === 5 || e.getDay() === 6 : !1;
    r.push({
      day: y(e, "d"),
      isActiveMonth: D(e, M),
      isCurrentDay: F(e),
      isStartDate: t ? l(e, t) : !1,
      isEndDate: s ? l(e, s) : !1,
      isInRange: t && s ? S(e, { start: t, end: s }) : !1,
      date: e,
      isStartOfWeek: V(e),
      isEndOfWeek: _(e),
      disabled: w || I || A || C,
      // Add the disabled property based on minDate, maxDate, and disabledDates
      isEventDay: m
      // Add the isEventDay property
    }), e = k(e, 1);
  }
  return r;
}, dt = (o, t, s, n, a, i, f) => {
  const h = new Date(o).getFullYear(), u = new Date(o).getMonth(), p = b(new Date(h, u, 1)), M = U(p), c = j(k(M, 41)), d = [];
  let r = M;
  for (; r <= c; ) {
    const e = n ? B(r, n) : !1, w = a ? O(r, a) : !1, I = !!(i != null && i.some((m) => l(r, m))), A = !!(f != null && f.some((m) => l(r, m)));
    d.push({
      month: y(r, "MMM"),
      isCurrentDay: F(r),
      isStartDate: t ? D(r, t) : !1,
      isEndDate: s ? D(r, s) : !1,
      isInRange: t && s ? S(r, { start: t, end: s }) : !1,
      date: r,
      isStartColumn: [0, 3, 6, 9].includes(r.getMonth()),
      isEndColumn: [2, 5, 8, 11].includes(r.getMonth()),
      disabled: e || w || I,
      // Add the disabled property based on minDate, maxDate, and disabledDates
      isEventDay: A
      // Add the isEventDay property
    }), r = W(r, 1);
  }
  return d;
};
export {
  rt as DEFAULT_DATE_FORMAT,
  ft as compareDatesByMonth,
  ct as getDaysInMonthArray,
  yt as getEndDate,
  dt as getMonthsInYearArray,
  nt as getStartDate,
  mt as isTodayDisabled,
  Mt as isYearDisabled,
  at as nextMonth,
  it as prevMonth,
  lt as tabItems
};
//# sourceMappingURL=calender.helper.js.map
